import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear(event) {
    event.preventDefault()
    
    const url = new URL(this.element.href)
    window.history.replaceState({}, '', url)

    // Dispatch event to clear all filter inputs
    document.dispatchEvent(new CustomEvent('filters:clear'))
    
    // Dispatch event for filter changes
    window.dispatchEvent(new CustomEvent('filters:changed'))

    // Make the Turbo visit
    Turbo.visit(url, { 
      action: 'replace', 
      frame: 'crud_content' 
    })
  }
} 
